// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});
$('a#scroller').on('click', function (e) {
  e.preventDefault();
  const href = $(this).attr('href');

  $('html, body').animate({ scrollTop: $(href).offset().top }, 800);
});
if ( $( '.carousel' ).length ) {

$('.carousel').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  accessibility: false,

  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        dots: true,
        accessibility: false,

        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    
  ],
});

$('select').on('change', function() {
  var val = this.value;
  $( '.grid .post' )
  .each(function(  ) {
    if(!val) {
      $(this).removeClass('hidden');
    } else {
      if($( this ).hasClass('category-' + val)){
        $(this).removeClass('hidden');
      } else {
        $(this).addClass('hidden');
      }
    }
  });
});

}

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js